import { FirebaseOptions, initializeApp } from 'firebase/app'
import { initializeAppCheck } from 'firebase/app-check'
import {
	browserPopupRedirectResolver,
	initializeAuth as initializeFirebaseAuth,
	inMemoryPersistence
} from 'firebase/auth'

import { broadcastSuccessSignIn } from 'utils'

import { customCheckProvider } from './custom_appcheck_provider'
import { authStatus, updateFirebaseAppCheckState } from './state'
import { AuthState } from './types'

/**
 * @param tenantId default tenantId to which the users will sign in/up against
 * @param config firebase configuration
 */
export const initializeFirebase = (
	tenantId: string,
	config: FirebaseOptions
) => {
	// 1. Initialize firebase app and start auth process
	const app = initializeApp(config)

	// 2. Initialize app check to make authorize
	// request to google apis
	const appCheck = initializeAppCheck(app, {
		provider: customCheckProvider,
		isTokenAutoRefreshEnabled: false
	})

	// 3- Set the app check
	updateFirebaseAppCheckState(() => appCheck)

	// 4. Initialize firebase auth with default tenant
	const auth = initializeFirebaseAuth(app, {
		persistence: inMemoryPersistence,
		popupRedirectResolver: browserPopupRedirectResolver
	})

	auth.tenantId = tenantId

	// 5. Set up a listener for auth status changes. If the user’s state transitions
	// to `authenticated`, we broadcast an auth success message. We then dispose of
	// the listener.
	const disposeAuthStatusListener = authStatus.onUpdateState(state => {
		if (state === AuthState.authenticated) {
			broadcastSuccessSignIn()

			disposeAuthStatusListener()
		}
	})

	return { auth, app, appCheck }
}
